/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SubmitApplicationFlowRequest": {
                "fields": {
                  "applicationFlowId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SubmitApplicationFlowResponse": {
                "fields": {
                  "applicationFlow": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SubmitApplicationFlowRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SubmitApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SubmitApplicationFlowRequest @ squareup/corporate_card/service/submit_application_flow.proto at 10:1
 */
export const SubmitApplicationFlowRequest = $root.lookupType('squareup.corporate_card.service.SubmitApplicationFlowRequest');
fixType(SubmitApplicationFlowRequest, {
  applicationFlowId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(SubmitApplicationFlowRequest);
/**
 * SOURCE SubmitApplicationFlowResponse @ squareup/corporate_card/service/submit_application_flow.proto at 19:1
 */
export const SubmitApplicationFlowResponse = $root.lookupType('squareup.corporate_card.service.SubmitApplicationFlowResponse');
fixType(SubmitApplicationFlowResponse);
Builder.createAndAttachToType(SubmitApplicationFlowResponse);